// Company sizes
export const COMPANY_SIZES = [
  { value: "1-10", label: "1-10 employees" },
  { value: "11-50", label: "11-50 employees" },
  { value: "51-200", label: "51-200 employees" },
  { value: "201-500", label: "201-500 employees" },
  { value: "501-1000", label: "501-1000 employees" },
  { value: "1000+", label: "1000+ employees" },
] as const;

// Industries
export const INDUSTRIES = [
  { value: "technology", label: "Technology" },
  { value: "healthcare", label: "Healthcare" },
  { value: "finance", label: "Finance" },
  { value: "education", label: "Education" },
  { value: "retail", label: "Retail" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "consulting", label: "Consulting" },
  { value: "media", label: "Media & Entertainment" },
  { value: "nonprofit", label: "Non-profit" },
  { value: "government", label: "Government" },
  { value: "real-estate", label: "Real Estate" },
  { value: "transportation", label: "Transportation" },
  { value: "food", label: "Food & Beverage" },
  { value: "other", label: "Other" },
] as const;

// Job roles
export const JOB_ROLES = [
  { value: "ceo", label: "CEO/Founder" },
  { value: "cto", label: "CTO" },
  { value: "product-manager", label: "Product Manager" },
  { value: "engineering-manager", label: "Engineering Manager" },
  { value: "developer", label: "Developer" },
  { value: "designer", label: "Designer" },
  { value: "marketing", label: "Marketing" },
  { value: "sales", label: "Sales" },
  { value: "operations", label: "Operations" },
  { value: "hr", label: "Human Resources" },
  { value: "finance", label: "Finance" },
  { value: "customer-success", label: "Customer Success" },
  { value: "other", label: "Other" },
] as const;

// Countries (top 50 most common)
export const COUNTRIES = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "GB", label: "United Kingdom" },
  { value: "AU", label: "Australia" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "IT", label: "Italy" },
  { value: "ES", label: "Spain" },
  { value: "NL", label: "Netherlands" },
  { value: "BE", label: "Belgium" },
  { value: "CH", label: "Switzerland" },
  { value: "AT", label: "Austria" },
  { value: "SE", label: "Sweden" },
  { value: "NO", label: "Norway" },
  { value: "DK", label: "Denmark" },
  { value: "FI", label: "Finland" },
  { value: "IE", label: "Ireland" },
  { value: "PT", label: "Portugal" },
  { value: "PL", label: "Poland" },
  { value: "CZ", label: "Czech Republic" },
  { value: "HU", label: "Hungary" },
  { value: "RO", label: "Romania" },
  { value: "BG", label: "Bulgaria" },
  { value: "HR", label: "Croatia" },
  { value: "SI", label: "Slovenia" },
  { value: "SK", label: "Slovakia" },
  { value: "LT", label: "Lithuania" },
  { value: "LV", label: "Latvia" },
  { value: "EE", label: "Estonia" },
  { value: "GR", label: "Greece" },
  { value: "TR", label: "Turkey" },
  { value: "RU", label: "Russia" },
  { value: "UA", label: "Ukraine" },
  { value: "BY", label: "Belarus" },
  { value: "MD", label: "Moldova" },
  { value: "RS", label: "Serbia" },
  { value: "BA", label: "Bosnia and Herzegovina" },
  { value: "ME", label: "Montenegro" },
  { value: "MK", label: "North Macedonia" },
  { value: "AL", label: "Albania" },
  { value: "XK", label: "Kosovo" },
  { value: "JP", label: "Japan" },
  { value: "KR", label: "South Korea" },
  { value: "CN", label: "China" },
  { value: "IN", label: "India" },
  { value: "SG", label: "Singapore" },
  { value: "HK", label: "Hong Kong" },
  { value: "TW", label: "Taiwan" },
  { value: "MY", label: "Malaysia" },
  { value: "TH", label: "Thailand" },
  { value: "ID", label: "Indonesia" },
  { value: "PH", label: "Philippines" },
  { value: "VN", label: "Vietnam" },
  { value: "BD", label: "Bangladesh" },
  { value: "PK", label: "Pakistan" },
  { value: "LK", label: "Sri Lanka" },
  { value: "NP", label: "Nepal" },
  { value: "MM", label: "Myanmar" },
  { value: "KH", label: "Cambodia" },
  { value: "LA", label: "Laos" },
  { value: "BN", label: "Brunei" },
  { value: "MN", label: "Mongolia" },
  { value: "NZ", label: "New Zealand" },
  { value: "FJ", label: "Fiji" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "BR", label: "Brazil" },
  { value: "AR", label: "Argentina" },
  { value: "CL", label: "Chile" },
  { value: "CO", label: "Colombia" },
  { value: "PE", label: "Peru" },
  { value: "VE", label: "Venezuela" },
  { value: "EC", label: "Ecuador" },
  { value: "BO", label: "Bolivia" },
  { value: "PY", label: "Paraguay" },
  { value: "UY", label: "Uruguay" },
  { value: "GY", label: "Guyana" },
  { value: "SR", label: "Suriname" },
  { value: "GF", label: "French Guiana" },
  { value: "MX", label: "Mexico" },
  { value: "GT", label: "Guatemala" },
  { value: "BZ", label: "Belize" },
  { value: "SV", label: "El Salvador" },
  { value: "HN", label: "Honduras" },
  { value: "NI", label: "Nicaragua" },
  { value: "CR", label: "Costa Rica" },
  { value: "PA", label: "Panama" },
  { value: "ZA", label: "South Africa" },
  { value: "EG", label: "Egypt" },
  { value: "MA", label: "Morocco" },
  { value: "TN", label: "Tunisia" },
  { value: "DZ", label: "Algeria" },
  { value: "LY", label: "Libya" },
  { value: "SD", label: "Sudan" },
  { value: "ET", label: "Ethiopia" },
  { value: "KE", label: "Kenya" },
  { value: "UG", label: "Uganda" },
  { value: "TZ", label: "Tanzania" },
  { value: "RW", label: "Rwanda" },
  { value: "BI", label: "Burundi" },
  { value: "DJ", label: "Djibouti" },
  { value: "SO", label: "Somalia" },
  { value: "ER", label: "Eritrea" },
  { value: "SS", label: "South Sudan" },
  { value: "CF", label: "Central African Republic" },
  { value: "TD", label: "Chad" },
  { value: "CM", label: "Cameroon" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "ST", label: "Sao Tome and Principe" },
  { value: "GA", label: "Gabon" },
  { value: "CG", label: "Congo" },
  { value: "CD", label: "Congo (Democratic Republic)" },
  { value: "AO", label: "Angola" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
  { value: "BW", label: "Botswana" },
  { value: "NA", label: "Namibia" },
  { value: "SZ", label: "Eswatini" },
  { value: "LS", label: "Lesotho" },
  { value: "MW", label: "Malawi" },
  { value: "MZ", label: "Mozambique" },
  { value: "MG", label: "Madagascar" },
  { value: "MU", label: "Mauritius" },
  { value: "SC", label: "Seychelles" },
  { value: "KM", label: "Comoros" },
  { value: "CV", label: "Cape Verde" },
  { value: "GW", label: "Guinea-Bissau" },
  { value: "GN", label: "Guinea" },
  { value: "SL", label: "Sierra Leone" },
  { value: "LR", label: "Liberia" },
  { value: "CI", label: "Ivory Coast" },
  { value: "GH", label: "Ghana" },
  { value: "TG", label: "Togo" },
  { value: "BJ", label: "Benin" },
  { value: "BF", label: "Burkina Faso" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "ML", label: "Mali" },
  { value: "MR", label: "Mauritania" },
  { value: "SN", label: "Senegal" },
  { value: "GM", label: "Gambia" },
] as const;

// Use cases
export const USE_CASES = [
  { value: "customer-support", label: "Customer Support" },
  { value: "lead-generation", label: "Lead Generation" },
  { value: "sales-automation", label: "Sales Automation" },
  { value: "marketing-campaigns", label: "Marketing Campaigns" },
  { value: "appointment-booking", label: "Appointment Booking" },
  { value: "team-collaboration", label: "Team Collaboration" },
  { value: "project-management", label: "Project Management" },
  { value: "knowledge-base", label: "Knowledge Base" },
  { value: "workflow-automation", label: "Workflow Automation" },
  { value: "analytics", label: "Analytics & Reporting" },
  { value: "integrations", label: "Third-party Integrations" },
  { value: "custom-development", label: "Custom Development" },
] as const;

// Goals
export const GOALS = [
  { value: "increase-productivity", label: "Increase Team Productivity" },
  {
    value: "improve-customer-satisfaction",
    label: "Improve Customer Satisfaction",
  },
  { value: "reduce-response-time", label: "Reduce Response Time" },
  { value: "automate-processes", label: "Automate Manual Processes" },
  { value: "scale-operations", label: "Scale Operations" },
  { value: "improve-collaboration", label: "Improve Team Collaboration" },
  { value: "reduce-costs", label: "Reduce Operational Costs" },
  { value: "increase-revenue", label: "Increase Revenue" },
  { value: "better-insights", label: "Get Better Business Insights" },
  { value: "enhance-security", label: "Enhance Security" },
] as const;

// Experience levels
export const EXPERIENCE_LEVELS = [
  { value: "beginner", label: "Beginner - New to conversational AI" },
  {
    value: "intermediate",
    label: "Intermediate - Some experience with chatbots",
  },
  { value: "advanced", label: "Advanced - Extensive experience with AI tools" },
] as const;

// Application constants
export const APP_NAME = "Just Ping";
export const APP_VERSION = "1.0.0";
export const APP_DESCRIPTION = "Conversational AI Platform";

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh-token",
    VERIFY: "/auth/verify",
    RESET_PASSWORD: "/auth/reset-password",
    FORGOT_PASSWORD: "/auth/forgot-password",
    ACCEPT_INVITATION: "/auth/accept-invitation",
    CHANGE_PASSWORD: "/auth/change-password",
  },
  USER: {
    PROFILE: "/user/profile",
    PREFERENCES: "/user/preferences",
  },
  BUSINESS: {
    PROFILE: "/business",
    UPDATE: "/business",
    PROFILE_IMAGE: "/business/profile-image",
  },
  TEAM: {
    LIST: "/teams",
    INVITE: "/team/invite",
    UPDATE: "/team/members",
    DELETE: "/team/members",
    ROLES: "/roles",
  },
  ONBOARDING: {
    SAVE: "/onboarding/save",
    COMPLETE: "/onboarding/complete",
  },
  CHANNELS: {
    LIST: "/channels",
  },
  TEMPLATES: {
    LIST: "/templates",
    CREATE: "/templates",
    UPDATE: "/templates",
    DELETE: "/templates",
    SUBMIT: "/templates",
    DUPLICATE: "/templates",
    VALIDATE: "/templates/validate",
  },
  KNOWLEDGE_BASE: {
    FILES: "/knowledge-base/files",
    FILE: "/knowledge-base/files",
    UPLOAD: "/knowledge-base/files/upload",
    DELETE: "/knowledge-base/files",
    INDEXES: "/knowledge-base/indexes",
    INDEX: "/knowledge-base/indexes",
    ADD_FILES_TO_INDEX: "/knowledge-base/indexes",
    CLOUD_STORAGE_FILES: "/knowledge-base/cloud-storage/files",
    CLOUD_STORAGE_SYNC: "/knowledge-base/cloud-storage/sync",
    CLOUD_STORAGE_DISCONNECT: "/knowledge-base/cloud-storage/disconnect",
  },
} as const;

// Local storage keys
export const STORAGE_KEYS = {
  USER: "justping_user",
  TOKEN: "justping_token",
  REFRESH_TOKEN: "justping_refresh_token",
  THEME: "justping_theme",
  ONBOARDING: "justping_onboarding",
  PREFERENCES: "justping_preferences",
  LIBRARY: "justping_library",
} as const;

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: "This field is required",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_PASSWORD: "Password must be at least 8 characters long",
  PASSWORDS_DONT_MATCH: "Passwords do not match",
  NETWORK_ERROR:
    "Unable to connect. Please check your internet connection and try again.",
  UNAUTHORIZED: "Please log in to continue",
  FORBIDDEN: "You don't have permission to perform this action",
  NOT_FOUND: "The requested information could not be found",
  SERVER_ERROR:
    "Something went wrong on our end. Please try again in a few moments.",
  UNKNOWN_ERROR: "Something unexpected happened. Please try again.",
  // Additional HTTP error messages
  BAD_REQUEST: "Please check your information and try again.",
  CONFLICT:
    "This action conflicts with existing data. Please refresh and try again.",
  GONE: "This content is no longer available.",
  PAYLOAD_TOO_LARGE:
    "The file you're trying to upload is too large. Please choose a smaller file.",
  UNSUPPORTED_MEDIA_TYPE:
    "This file type is not supported. Please choose a different file.",
  TOO_MANY_REQUESTS:
    "You're doing that too quickly. Please wait a moment and try again.",
  BAD_GATEWAY:
    "We're experiencing technical difficulties. Please try again later.",
  SERVICE_UNAVAILABLE:
    "The service is temporarily unavailable. Please try again in a few minutes.",
  GATEWAY_TIMEOUT:
    "The request is taking longer than expected. Please try again.",
  INVALID_CREDENTIALS: "Invalid email or password.",
  ACCOUNT_LOCKED:
    "Your account has been temporarily locked. Please contact support.",
  TOKEN_EXPIRED: "Your session has expired. Please log in again.",

  // Context-specific error messages
  ENDPOINT_NOT_FOUND:
    "This feature is temporarily unavailable. Please try again later.",
  TEAM_NOT_FOUND:
    "Team not found. It may have been deleted or you may not have access.",
  USER_NOT_FOUND: "User not found. Please check the information and try again.",
  CHANNEL_NOT_FOUND: "Channel not found. It may have been deleted or moved.",
  BUSINESS_NOT_FOUND:
    "Business profile not found. Please check your information.",
  INVITATION_NOT_FOUND: "Invitation not found or may have expired.",
  ROLE_NOT_FOUND: "Role not found. Please refresh the page and try again.",

  // Operation-specific messages
  UPLOAD_FAILED: "File upload failed. Please try again.",
  SAVE_FAILED: "Unable to save changes. Please try again.",
  DELETE_FAILED: "Unable to delete. Please try again.",
  UPDATE_FAILED: "Unable to update. Please try again.",
  LOAD_FAILED: "Unable to load data. Please refresh the page.",

  // Generic fallbacks
  OPERATION_FAILED: "Operation failed. Please try again.",
  DATA_UNAVAILABLE: "Data is temporarily unavailable. Please try again later.",
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: "Successfully logged in",
  REGISTER_SUCCESS: "Account created successfully",
  LOGOUT_SUCCESS: "Successfully logged out",
  PROFILE_UPDATED: "Profile updated successfully",
  PREFERENCES_UPDATED: "Preferences updated successfully",
  ONBOARDING_COMPLETED: "Onboarding completed successfully",
  TEAM_MEMBER_INVITED: "Team member invited successfully",
  TEAM_MEMBER_UPDATED: "Team member updated successfully",
  TEAM_MEMBER_REMOVED: "Team member removed successfully",
  PROVIDER_CREATED: "Provider created successfully",
  PROVIDER_UPDATED: "Provider updated successfully",
  PROVIDER_DELETED: "Provider deleted successfully",
} as const;
